export default "__VITE_ASSET__CnbbPfQb__"